<template>
  <div>
    <div v-if="event">
      <h2>{{event.path}}</h2>
      <div class="text-right text-muted">{{event.createAt | moment('YYYY-MM-DD HH:mm:ss')}}</div>

      <div>
        <p>시작일 : {{ event.startAt | moment }}</p>
        <p>종료일 : {{ event.endAt | moment }}</p>
        <p>상담 신청 : {{ event.useCounsel ? '가능' : '불가능' }}</p>
      </div>

      <hr/>

      <template v-if="event.img1 !== null && event.img1 !== ''">
        <h5>썸네일 이미지(PC)<small class="text-muted ml-3">{{event.img1}}</small></h5>
        <img :src="`${publicPath}upload/event/${event.img1}`" />
      </template>

      <hr/>

      <template v-if="event.img2 !== null && event.img2 !== ''">
        <h5>썸네일 이미지(Mobile)<small class="text-muted ml-3">{{event.img2}}</small></h5>
        <img :src="`${publicPath}upload/event/${event.img2}`" />
      </template>

      <div class="text-center my-3">
        <router-link
          tag="button"
          class="btn  btn-outline-secondary mx-1"
          :to="{name:'adminEventEdit', params: {id: event.id}}">
          수정
        </router-link>
        <button type="button" class="btn  btn-outline-danger mx-1" @click="remove">삭제</button>
        <button type="button" class="btn  btn-outline-secondary mx-1" @click="$router.back()">목록</button>
      </div>
    </div>


  </div>
</template>

<script>
export default {
  name: 'AdminEventView',
  data() {
    return {
      event: null,
    };
  },
  mounted() {
    if (this.$route.params && this.$route.params.id) {
      this.axios.get(`/admin/event/${this.$route.params.id}`)
        .then(({ data }) => {
          this.event = data;
        })
        .catch(() => {
          this.$router.push({ name: 'adminEventList' });
        });
    } else {
      this.$router.push({ name: 'adminEventList' });
    }
  },
  methods: {
    remove() {
      // eslint-disable-next-line no-restricted-globals,no-alert
      if (confirm('삭제하시겠습니까?')) {
        this.$axios.delete(`/admin/event/${this.event.id}`)
          .then(() => {
            this.$router.push({ name: 'adminEventList' });
          });
      }
    },
  },
};
</script>

<style scoped>

</style>
